import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import { optimizelyFeatureFlags } from '../../constants/optimizely';
import { useOptimizely } from '../UserAnalytics/hooks/useOptimizely';

const GATSBY_ENV = process.env.GATSBY_ENV;
const GATSBY_GNATTA_API_KEY = process.env.GATSBY_GNATTA_API_KEY;
const GATSBY_GNATTA_ACCOUNT_ID = process.env.GATSBY_GNATTA_ACCOUNT_ID;
const isLocal = GATSBY_ENV === 'local';

const SiteScripts = () => {
  const gnattaWebchatDecision = useOptimizely(optimizelyFeatureFlags.GNATTA_WEB_CHAT);
  useEffect(() => {
    if (!isLocal) {
      (function () {
        const additionalScriptTag = document.createElement('script');
        additionalScriptTag.src =
          'https://cdn-ukwest.onetrust.com/consent/7621ed8f-c9a3-48a9-b164-a81246835c3d/OtAutoBlock.js';
        additionalScriptTag.async = true;
        document.body.appendChild(additionalScriptTag);

        const scriptTag = document.createElement('script');
        scriptTag.src = 'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js';
        scriptTag.setAttribute('data-domain-script', '7621ed8f-c9a3-48a9-b164-a81246835c3d');
        document.body.appendChild(scriptTag);
      })();
    }
  }, []);

  useEffect(() => {
    // Create a script element
    if (gnattaWebchatDecision.enabled && !isLocal) {
      (function () {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://chat.system.gnatta.com/script/app.js';
        script.async = true;
        // Append the script to the head of the document
        document.head.appendChild(script);
        // Initialize the Gnatta chat system when the script is loaded
        script.onload = () => {
          window.gnatta.start(GATSBY_GNATTA_API_KEY, 'https://chat.system.gnatta.com');
          window.gnatta.register(
            GATSBY_GNATTA_ACCOUNT_ID!,
            'gwc-chatAvailable',
            'gwc-chatBusy',
            'gwc-chatOffline'
          );
        };
      })();
    }
  }, []);
  return (
    <Helmet defer>
      <script
        type="text/javascript"
        src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        async
      />
    </Helmet>
  );
};

export default SiteScripts;
